module.exports = __webpack_public_path__ + "img/dreieckslast.646f0771.jpg";